/*Get PROGRAM */
export const GET_NAVIGATION_SIDEBAR = "GET_NAVIGATION_SIDEBAR"
export const GET_NAVIGATION_SIDEBAR_SUCCESS = "GET_NAVIGATION_SIDEBAR_SUCCESS"
export const GET_NAVIGATION_SIDEBAR_FAIL = "GET_NAVIGATION_SIDEBAR_FAIL"
